import React from 'react';
import { Button, ButtonGroup } from '@blueprintjs/core';
import CacheTable from './cachetable';

export default class SolutionVisualizer extends React.Component {

    constructor(props) {
        super(props);
        this.state = { final: true, step: 1 };
    }

    styleRATItem(step, reg, styled) {
        const oriReg = reg < 8 ? "R"+reg : "D"+(reg-8); 
        const text = (reg < 8 ? "U" : "T") + this.props.rat[step][reg];
        if (styled && step > 0 && oriReg === this.props.origInstrList[step-1].targetReg)
            return <span className="registerrenaming-rat-item-newtarget">{text}</span>;
        else if (styled && step > 0 && (oriReg === this.props.origInstrList[step-1].regA || oriReg === this.props.origInstrList[step-1].regB))
            return <span className="registerrenaming-rat-item-renamed">{text}</span>;
        else 
            return <span className="registerrenaming-rat-item-other">{text}</span>;
    }

    static getDerivedStateFromProps(props, state) {
        if (props && props.addresses) {
            if (state.step > props.addresses.length)
                return { step: props.addresses.length };
        }
        return null;
    }


    renderAddressPanel(address) {
        return <div>
            <p>A {address.address} cím összetevői:</p>
            <p>Index: <span className="demo-solution-value">{address.index}</span></p>
            <p>Tag: <span className="demo-solution-value">{address.tag}</span></p>
        </div>;
    }

    render() {
        return <>
            <div className="cachemem-solution-container">
                <div className="cachemem-solution-controls">
                    <ButtonGroup>
                        <Button 
                            text="Végeredmény"
                            active={this.state.final}
                            onClick={() => this.setState({final: true})}
                        />
                        <Button 
                            text="Lépésenként"
                            active={!this.state.final}
                            onClick={() => this.setState({final: false})}
                        />
                    </ButtonGroup>
                    <div className="cachemem-solution-steps" style={{ visibility: this.state.final ? "hidden" : "visible"}}>
                        <ButtonGroup>
                            <Button 
                                icon="caret-left"
                                onClick={() => this.setState(state => ({ step: Math.max(1, state.step-1)}))}
                            />
                            <Button 
                                icon="caret-right"
                                onClick={() => this.setState(state => ({step: Math.min(this.props.addresses.length, state.step+1)}))}
                            />
                        </ButtonGroup>                    
                        <div>{this.props.addresses[this.state.step-1].address} meghivatkozása:</div>
                    </div>                    
                </div>

                <div className="cachemem-solution-main">
                    {this.state.final===false && this.renderAddressPanel(this.props.addresses[this.state.step-1])}
                    <div className="cachemem-solution-state">
                        <p>{this.state.final ? "A cache végállapota:" : "Állapot a hivatkozás után:"}</p>
                    <CacheTable 
                        content={this.props.content} 
                        ages={this.props.ages} 
                        step={this.state.final ? this.props.addresses.length : this.state.step}
                        address={this.props.addresses[this.state.step-1]}
                        markChanges={!this.state.final} 
                    />
                    </div>
                </div>            
            </div>
        </>;
    }

}
